import './App.css';
import { Banner } from './components/Banner';
import { NavBar } from './components/NavBar';
import { Skills } from './components/Skills';
import { Projects } from './components/Projets';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { Backend } from './components/Backend';
import { Blog } from './components/Blog';
import { MailchimpForm } from './components/MailchimpForm';
import { Resume } from './components/Resume';
import 'bootstrap/dist/css/bootstrap.min.css';
function App() {
  return (
    <div className="App">
     <NavBar />
     <Banner />
      <Skills />
      <Projects />
      <Backend />
      <Blog />
      <Resume />
      <Contact />
      <MailchimpForm />
      <Footer />
    </div>
  );
}

export default App;
